import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { http_get } from '../../utils/api_client';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { updateBackgroundURL } from '../../../../redux/stepsSlice';
import { getActiveStep } from '../../../../redux/toolsSlice';

// Walkthrough Editor v2 — cross-walkthrough Screenshot Library (BL-142).
// Replaces the dead right-rail "Library" tab. Lists every screenshot the
// company has captured (from any walkthrough), searchable, and inserts the
// chosen one into the active step via updateBackgroundURL — the same call the
// screenshot-capture flow already uses.

const WalkthroughScreenshotModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => getActiveStep(state));
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState('');
  const [tab, setTab] = useState('all'); // 'all' | 'recent'

  useEffect(() => {
    if (!open) return undefined;
    setLoading(true);
    http_get(API_ENDPOINTS.GET_LIBRARY_GALLERY)
      .then((res) => setItems(Array.isArray(res.data) ? res.data : []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
    return undefined;
  }, [open]);

  if (!open) return null;

  const norm = q.trim().toLowerCase();
  let list = tab === 'recent' ? items.slice(0, 12) : items;
  if (norm) list = list.filter((s) => (s.filename || '').toLowerCase().includes(norm));

  const use = (s) => {
    if (activeStep) dispatch(updateBackgroundURL({ stepId: activeStep.id, url: s.url }));
    onClose();
  };

  return (
    <div className="un-we-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="un-we-slib" role="dialog" aria-label="Insert a screenshot">
        <div className="un-we-slib__h">
          <div>
            <div className="t">Insert a screenshot</div>
            <div className="sub">Reuse a screenshot captured in any of your walkthroughs.</div>
          </div>
          <button type="button" className="x" aria-label="Close" onClick={onClose}>×</button>
        </div>

        <div className="un-we-slib__act">
          <div className="un-we-slib__search">
            <input type="text" placeholder="Search screenshots…" value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
          </div>
        </div>

        <div className="un-we-slib__body">
          <div className="un-we-slib__side">
            <button type="button" className={tab === 'all' ? 'on' : ''} onClick={() => setTab('all')}>
              All screenshots <span className="c">{items.length}</span>
            </button>
            <button type="button" className={tab === 'recent' ? 'on' : ''} onClick={() => setTab('recent')}>
              Recent
            </button>
          </div>

          <div className="un-we-slib__grid">
            {loading && <div className="un-we-slib__empty">Loading…</div>}
            {!loading && list.length === 0 && (
              <div className="un-we-slib__empty">No screenshots yet. Capture one from a step to build your library.</div>
            )}
            {!loading && list.map((s) => (
              <button type="button" key={s.id} className="un-we-sgi" title={s.filename || ''} onClick={() => use(s)}>
                <span className="un-we-sgi__thumb" style={{ backgroundImage: `url(${s.thumb || s.url})` }} />
                <span className="un-we-sgi__use">Use this</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalkthroughScreenshotModal;
